<nwm-menu />

<div class="content">
  <div class="main">
    <div class="row no-gutters mb-5 mt-4 pb-5">
      <div class="col-xxl-10 offset-xxl-1">
        <a href="/assets/PGF/Nicola%20Wealth%20Private%20Giving%20Foundation%20Guidelines.pdf" target="_blank" tabindex="0" class="btn btn-outline-primary d-print-none pull-right ml-3" style="margin-top:30px">Guidelines</a>
        <a href="https://nicolawealth.com/private-giving-foundation" target="_blank" tabindex="0" class="btn btn-outline-primary d-print-none pull-right" style="margin-top:30px">About the Foundation</a>
        <h1 class="mt-4 mb-3">Resources</h1>
        <p>Welcome to our donor community and Donor Advised Fund resources page. Our goal is to provide you with the administrative tools needed to make your giving experience rewarding and impactful. Here, you’ll find information about the Nicola Wealth Private Giving Foundation and the Nicola Wealth philanthropic vision.</p>

        <h1 class="mt-5 mb-4">Donor Advised Fund (DAF) – what you need to know </h1>
        <pgf-how-it-works />

        <pgf-pie />

        <button routerLink="/pgf/news" class="btn btn-outline-primary d-print-none pull-right mt-5">Explore All News</button>
        <h1 class="mt-5 mb-3" id="pgf_news" data-offset="-80">Recent News in the Community</h1>
        <news topic="PGF" [limit]="4" />

        <h1 class="mt-5">Nicola Wealth in the Community</h1>
        <p>Nicola Wealth is an active member of our communities, giving back and getting involved to help build a vibrant future. <a href="https://nicolawealth.com/insights/category/community" target="_blank">Learn about how our initiatives are making an impact and redefining success.</a></p>
      </div>
    </div>

  </div>
</div>

<div class="py-5 join-section">
  <button class="btn btn-NWM btn-light" (click)="modalService.open(pgfModal, { size: 'lg' })">Contact Us</button>
</div>

<ng-template #pgfModal let-modal>
  <nwm-advisor-contact formAction="MessageAdvisor" (formCancelled)="modal.close()" />
</ng-template>